import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
} from "@mui/material";
import Layout from "../../layout/Layout";
import { Link } from "react-router-dom";

import TableChartIcon from "@mui/icons-material/TableChart";
import Pagination from "@mui/material/Pagination";
import { PostAddOutlined } from "@mui/icons-material";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import {
  fetchCoworkings,
  deleteCoworking,
} from "../../services/coworking/coworkingAPI";

const pages = [
  {
    name: "Coworking Amenities Section",
    icon: <PostAddOutlined />,
    link: "/Coworking-amenities-section",
  },
  {
    name: "Coworking Category",
    icon: <PostAddOutlined />,
    link: "/coworking-category",
  },
  {
    name: "Coworking Distance Section",
    icon: <PostAddOutlined />,
    link: "/coworking-distance-section",
  },
  {
    name: "Coworking Documentation",
    icon: <PostAddOutlined />,
    link: "/coworking-documentation",
  },
  {
    name: "Coworking General Information",
    icon: <PostAddOutlined />,
    link: "/coworking-general-information",
  },
  {
    name: "Coworking Photo Gallery",
    icon: <PostAddOutlined />,
    link: "/coworking-photo-gallery",
  },
  {
    name: "Coworking Reviews",
    icon: <PostAddOutlined />,
    link: "/coworking-reviews",
  },
  {
    name: "Coworking Social Media",
    icon: <PostAddOutlined />,
    link: "/coworking-social-media",
  },
  {
    name: "Coworking Testimonials",
    icon: <PostAddOutlined />,
    link: "/coworking-testimonials",
  },
  {
    name: "Coworking Type Of Event",
    icon: <PostAddOutlined />,
    link: "/coworking-type-of-event",
  },
  {
    name: "Coworking Unit",
    icon: <PostAddOutlined />,
    link: "/coworking-unit",
  },
  {
    name: "Coworking Video Gallery",
    icon: <PostAddOutlined />,
    link: "/coworking-video-gallery",
  },
];

export default function Coworking() {
  const [coworkings, setCoworkings] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const [searchBy, setSearchBy] = useState("name");
  const [isTabularView, setIsTabularView] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [active, setActive] = useState("");
  const [coworkingsIdToDelete, setCoworkingsIdToDelete] = useState([]);
  const itemsPerPage = 6;

  useEffect(() => {
    fetchCoworkings()
      .then((data) => {
        setCoworkings(data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const handleDelete = () => {
    if (coworkingsIdToDelete) {
      deleteCoworking(coworkingsIdToDelete)
        .then(() => {
          setDeleteDialogOpen(false);
          setCoworkings((prevCoworkings) =>
            prevCoworkings.filter(
              (coworking) => coworking.id !== coworkingsIdToDelete
            )
          );
        })
        .catch((error) => {
          console.error(error.message);
        });
    }
  };

  const handleDeleteButtonClicked = (coworkingId) => {
    setDeleteDialogOpen(true);
    setCoworkingsIdToDelete(coworkingId);
  };

  const handleItemClick = (name) => {
    setActive(name);
  };

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  const handleSearchInputChange = (event) => {
    setSearchValue(event.target.value);
  };

  const handleSearchByChange = (event) => {
    setSearchBy(event.target.value);
  };

  const handleCloseDeleteDialog = () => {
    setDeleteDialogOpen(false);
  };

  const handleTabularViewToggle = () => {
    setIsTabularView(!isTabularView);
  };

  const filteredData = coworkings.filter((item) => {
    if (searchBy === "name") {
      return item.name.toLowerCase().includes(searchValue.toLowerCase());
    }
    if (searchBy === "city") {
      return item.city.toLowerCase().includes(searchValue.toLowerCase());
    }
    return true;
  });

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedData = filteredData.slice(startIndex, endIndex);

  return (
    <Layout>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div
          style={{
            width: "25%",
            height: "100vh",
            borderRight: "1px solid #ccc",
            boxShadow: "1px 2px 4px rgba(0, 0, 0, 0.1)",
            marginTop: "-50px",
          }}
        >
          <Typography
            variant="h5"
            gutterBottom
            sx={{ textAlign: "center", paddingTop: "20px" }}
          >
            Coworking Menu
          </Typography>
          <div
            style={{
              height: "82vh",
              overflowY: "auto",
              borderTop: "1px solid #ccc",
            }}
          >
            <List>
              {pages.map((page) => (
                <ListItem key={page.name} disablePadding>
                  <Box style={{ width: "100%" }}>
                    <Link
                      to={page.link}
                      onClick={() => handleItemClick(page.name)}
                      style={{
                        textDecoration: "none",
                        color: active === page.name ? "#49559d" : "#5A5A5A",
                        backgroundColor:
                          active === page.name ? "#49559d" : "#e2e2e2",
                        width: "100%",
                      }}
                    >
                      <ListItemButton>
                        <ListItemIcon
                          style={{
                            color: active === page.name ? "#49559d" : "#49559d",
                          }}
                        >
                          {page.icon}
                        </ListItemIcon>
                        <ListItemText
                          primary={page.name}
                          style={{
                            color: active === page.name ? "#49559d" : "#49559d",
                          }}
                        />
                      </ListItemButton>
                    </Link>
                  </Box>
                </ListItem>
              ))}
            </List>
          </div>
        </div>
        <div style={{ width: "79%" }}>
          <div>
            <div>
              <TextField
                value={searchValue}
                onChange={handleSearchInputChange}
                label="Search"
                variant="outlined"
                fullWidth
              />

              <select value={searchBy} onChange={handleSearchByChange}>
                <option value="name">Name</option>
                <option value="city">City</option>
              </select>
            </div>

            <Typography variant="h4" gutterBottom sx={{ textAlign: "center" }}>
              Coworking
            </Typography>

            <div>
              <Link
                to={{
                  pathname: "/add-new-coworking",
                  state: { isEditMode: false },
                }}
              >
                <Button variant="outlined">Add New</Button>
              </Link>

              <Button
                startIcon={<TableChartIcon />}
                onClick={handleTabularViewToggle}
              ></Button>
            </div>

            {filteredData.length === 0 ? (
              <Typography
                variant="h6"
                style={{
                  marginTop: "20px",
                  color: "red",
                  textAlign: "center",
                }}
              >
                There are no results
              </Typography>
            ) : (
              ""
            )}

            {!isTabularView ? (
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Title</TableCell>
                      <TableCell>Description</TableCell>
                      <TableCell>City</TableCell>
                      <TableCell>Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {paginatedData.reverse().map((item) => (
                      <TableRow key={item.id}>
                        <TableCell>{item.name}</TableCell>
                        <TableCell>{item.description}</TableCell>
                        <TableCell>{item.city}</TableCell>
                        <TableCell>
                          <div>
                            <Link
                              to={{
                                pathname: `/edit-coworking/${item.id}`,
                                state: { isEditMode: true },
                              }}
                            >
                              <Button variant="outlined">Edit Item</Button>
                            </Link>
                            <Button
                              variant="outlined"
                              onClick={() => handleDeleteButtonClicked(item.id)}
                            >
                              Delete
                            </Button>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <Grid container spacing={2}>
                {paginatedData.reverse().map((item) => (
                  <Grid item xs={12} sm={6} md={4} key={item.id}>
                    <Card>
                      <CardContent>
                        <Typography variant="h5" component="h2">
                          {item.name}
                        </Typography>
                        <Typography color="textSecondary">
                          {item.description}
                        </Typography>
                        <Typography color="textSecondary">
                          City: {item.city}
                        </Typography>
                        <Link
                          to={{
                            pathname: `/edit-coworking/${item.id}`,
                            state: { isEditMode: true },
                          }}
                        >
                          <Button variant="outlined">Edit item</Button>
                        </Link>
                        <Button
                          variant="outlined"
                          onClick={() => handleDeleteButtonClicked(item.id)}
                        >
                          Delete
                        </Button>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            )}
            <Pagination
              page={currentPage}
              onChange={handlePageChange}
              style={{ marginTop: "1rem", float: "right" }}
              count={Math.ceil(filteredData.length / itemsPerPage)}
            />

            <Dialog open={deleteDialogOpen} onClose={handleCloseDeleteDialog}>
              <DialogTitle>Delete Confirmation</DialogTitle>
              <DialogContent>
                <Typography>
                  Are you sure you want to delete this coworking?
                </Typography>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleCloseDeleteDialog} color="primary">
                  Cancel
                </Button>
                <Button
                  open={deleteDialogOpen}
                  onClose={() => setDeleteDialogOpen(false)}
                  onClick={handleDelete}
                  color="error"
                  autoFocus
                >
                  Delete
                </Button>
              </DialogActions>
            </Dialog>
          </div>
        </div>
      </div>
    </Layout>
  );
}
